import * as Sentry from '@sentry/react';

// DSN + Environment werden zur Build-Zeit von der GitLab-CI als REACT_APP_*-Vars
// reingereicht. Lokal sind sie leer → init wird übersprungen, Sentry ist no-op.
const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
    release: process.env.REACT_APP_SENTRY_RELEASE,
    // Free-Tier (5k Events/Monat) — nur Errors, keine Transactions/Replays.
    tracesSampleRate: 0.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
  });
}
